<template>
    <div>
        <div v-if="products.length > 0" class="position-absolute d-flex justify-content-center align-items-center comparecounter">
            <span>{{ products.length }}</span>
        </div>
        <div class="container-popup">
            <div :class="{'compareProducts': true,  'd-flex': this.open, 'hoverable': this.hoverable}">
                <div v-if="products.length==0">
                    <p>{{ t('compare.emptylist') }}</p>
                </div>
                <ul>
                    <li v-for="item in this.products" data-sku:="item.data.product.shopProductId">
                        <div class="product-image-container">
                            <img :src="item.data.product.medias[0].path" :alt="item.data.product.title" class="product-image">
                        </div>
                        <div class="product-center">
                            <h4>{{ item.data.product.title }}</h4>
                        </div>
                        <div @click="deleteItem(item.data.product.shopProductId)" class="deleteComparisonButton"/>
                    </li>
                </ul>
                <a :href="url" :class="[{'inactive' : this.products.length < 2}]">{{ t('compare.button') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import {eventBus} from 'fire-vue-core';
import {FireI18n} from 'fire-js-i18n';
export default {
    name: 'comparedropdown',
    data: () => ({
        products: [],
        getSelectedProducts: [],
        open: false,
        hoverable: true
    }),
    directives: {},
    mixins: [],
    props: {
        url: String,
    },
    watch: {

    },
    created()
    {

    },
    destroyed()
    {

    },
    mounted()
    {
        if (localStorage.comparisonProducts) {
                this.getSelectedProducts = JSON.parse(localStorage.comparisonProducts);
                this.fetchData();
        }


        eventBus.$on('updateDataCompareAll', (id) => {
            this.getSelectedProducts = JSON.parse(localStorage.comparisonProducts);
            this.fetchData();
            if (id && id === 'popup'){
                this.open = true;
                setTimeout(
                ()=>{
                    this.open = false;
                }, 5000
            )
            }


        });

    },
    methods: {
        fetchData() {
                return fetch(apiBaseUrl + "compare/get?ids=" + this.getSelectedProducts.join('_'))
                    .then((response) => response.json())
                    .then(data => {
                        this.products = data;
                    })
                    .catch(err => console.log(err));
        },
        deleteItem(id) {
            const index = this.getSelectedProducts.indexOf(id);
                console.log('delete dropdown ' + id);

                if (index > -1) {
                    this.getSelectedProducts.splice(index, 1); // Remove array element
                    localStorage.comparisonProducts = JSON.stringify(this.getSelectedProducts);
                }
                eventBus.$emit('updateDataCompareAll');
        },
        closeCompare() {
            this.open = false;
            setTimeout(
                ()=>{
                    this.hoverable = true;
                }, 1000
            )
        },
        t(key, options) {
            return FireI18n.t(key, options);
        },
    }
};
</script>